import { Input, Select, Space, Typography } from 'antd';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';
const { Option } = Select;

const Discovery = () => {
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Typography.Title level={4}>Filters</Typography.Title>
      <Space wrap>
        <Input
          placeholder="Search workflows..."
          prefix={<MagnifyingGlassIcon />}
          style={{ width: 300 }}
        />
        <Select placeholder="Status" style={{ width: 150 }} allowClear>
          <Option value="draft">Draft</Option>
          <Option value="active">Active</Option>
          <Option value="paused">Paused</Option>
          <Option value="completed">Completed</Option>
          <Option value="failed">Failed</Option>
        </Select>
      </Space>
    </Space>
  );
};

export default Discovery;
